<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-map-location text-blue" style="margin-right: 5px;"></i>门店省市统计</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading" class="chart-container">
      <div class="filter-bar">
        <span class="filter-label">品牌筛选：</span>
        <el-select v-model="selectedBrand" placeholder="请选择品牌" @change="handleBrandChange" size="small">
          <el-option v-for="brand in brandOptions" :key="brand" :label="brand" :value="brand"></el-option>
        </el-select>
      </div>
      <div ref="provinceChart" style="width: 100%; height: 270px;"></div>
    </div>
  </el-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'StoreProvinceStatistics',
  props: {
    url: {
      type: String,
      default: 'zhaoshang/zongjian/storeProvinceStatistics'
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      chart: null,
      selectedBrand: '全部',
      brandOptions: ['全部', '美滋滋', '蛮碗香', '长安大东家', '虎头张', '代运营'],
      data: {
        province: {}
      }
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    handleBrandChange () {
      this.fetchData()
    },
    async fetchData () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get(this.url, {
          params: {
            brand: this.selectedBrand
          }
        })

        if (res.meta.status === 200) {
          this.data = res.data
          this.$nextTick(() => {
            this.initChart()
          })
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取门店省市统计失败')
      } finally {
        this.loading = false
      }
    },
    initChart () {
      if (!this.$refs.provinceChart) return

      if (this.chart) {
        this.chart.dispose()
      }

      this.chart = echarts.init(this.$refs.provinceChart)

      const provinces = Object.keys(this.data.province)
      const values = Object.values(this.data.province)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: provinces,
          axisLabel: {
            interval: 0,
            rotate: 45,
            fontSize: 11
          }
        },
        yAxis: {
          type: 'value',
          name: '门店数量'
        },
        series: [
          {
            name: '门店数量',
            type: 'bar',
            data: values,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#409EFF'
                },
                {
                  offset: 1,
                  color: '#83B6FF'
                }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            barWidth: '50%',
            label: {
              show: true,
              position: 'top',
              formatter: '{c}'
            }
          }
        ]
      }

      this.chart.setOption(option)
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.chart-container {
  padding: 10px 0;
}
.filter-bar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.filter-label {
  font-size: 14px;
  color: #606266;
  margin-right: 10px;
}
</style>
